
import { defineComponent } from 'vue'
import { modifyPassword } from '@/api/base'
export default defineComponent({
    name: 'CodeChange',
    data () {
        return {
            oldCode: '',
            newCode: '',
            confirmCode: '',
            isConfirmCode: false
        }
    },

    methods: {
        async onModifyCode () {
            if (!this.oldCode) {
                this.$message.error('请输入原密码')
                return
            }
            if (this.newCode.length < 6) {
                this.$message.error('新密码至少输入六位')
                return
            }
            if (!this.blurNewCode()) {
                return
            }
            if (this.isConfirmCode) {
                await modifyPassword({
                    newPassword: this.newCode,
                    oldPassword: this.oldCode
                })
                localStorage.removeItem('isDefaultPassword')
                this.$message.success('密码修改成功')
                this.$router.push({
                    path: '/'
                })
            } else {
                this.$message.error('请确认两次密码是否一致')
            }
        },
        blurConfirmCode () {
            if (!this.blurNewCode()) {
                return
            }
            if (this.confirmCode !== this.newCode && this.confirmCode && this.newCode) {
                this.$message.error('请确认两次密码是否同样')
                this.isConfirmCode = false
            } else {
                this.isConfirmCode = true
            }
        },
        blurNewCode () {
            if (!/^(?=.*[a-zA-Z])(?=.*\d).+$/.test(this.newCode)) {
                this.$message.error('密码必须包含数字和字母')
                return false
            }
            if (/1234/.test(this.newCode)){
                this.$message.error('密码不能太过简单')
                return false
            }
            if (/qaz/.test(this.newCode)){
                this.$message.error('密码不能太过简单')
                return false
            }
            if (this.newCode.length < 6) {
                this.$message.error('密码长度不能小于6位')
                return false
            }
            return true
        }
    }
})
